/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : FilesTable.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : ConfigTable component
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : Jan 7, 2022
 *
 * @Version      : Version 1.0
 *
 * By            : <Changed By user id>
 * On            :  <Change Date>
 * Description   : <Change Description>
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { ICellData } from "@scuf/datatable/dist/components/DataTable/IDataTableInterfaces";
import "./StatusColumnRenderer.scss";
import { ReactComponent as InProgressSvg } from "./in-progress.svg";
import { ReactComponent as CompletedSvg } from "./completed.svg";
import { EnumCurrentApmFileRecordStatus } from "models/configuration";

interface IStatusColumnRendererProps {
  cellData: ICellData;
}

export const StatusColumnRenderer: FC<IStatusColumnRendererProps> = ({
  cellData,
}) => {
  const { rowData } = cellData;

  return (
    <span className="status-text-container">
      {rowData.status === EnumCurrentApmFileRecordStatus.completed ? (
        <>
          <CompletedSvg className="completed-icon" />
          Completed
        </>
      ) : (
        <>
          <InProgressSvg className="in-progress-icon" />
          In_Progress
        </>
      )}
    </span>
  );
};
